export default __webpack_public_path__ + "static/O0011-fca40f72011ba22c91774bfb125fad74.png";